


export default class InputsHelper {
	// % protected region % [Customise getAriaDescribedBy here] off begin
	public static getAriaDescribedBy(id: string, tooltip?: string, subDescription?: string) {
		const tooltipId = `${id}-tooltip`;
		const subDescriptionId = `${id}-sub-description`;

		if (tooltip) {
			return tooltipId;
		}

		return subDescription ? subDescriptionId : undefined;
	}
	// % protected region % [Customise getAriaDescribedBy here] end

	// % protected region % [Customise getAriaLabel here] off begin
	public static getAriaLabel(label: React.ReactNode, labelVisible: boolean | undefined): string | undefined {
		if (labelVisible === false && typeof label === 'string') {
			return label;
		}

		return undefined;
	}
	// % protected region % [Customise getAriaLabel here] end


}
